import { Plan } from "../Entities/Plan";
import apiClient from "./api.client.service";

class PlanService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getAllPlans(): Promise<Plan[]> {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/plans`);
      return response?.data || [];
    } catch (error: any) {
      console.error("getAllPlans - > error", error);
      return [];
    }
  }

  async getPlanById(planId: string): Promise<Plan | null> {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/plans/${planId}`);
      return response?.data || null;
    } catch (error: any) {
      console.error("getPlanById - > error", error);
      return null;
    }
  }

  async getAddonPlanByType(type: "job-application" | "job-post"): Promise<Plan | null> {
    try{
      const response = await apiClient.get(`${this.APIBaseUrl}/plans/addon/${type}`);
      return response?.data || null;
    }catch(error:any){
      console.error("getAddonPlanByType - > error", error);
      return null;
    }
  }
}

const planService = new PlanService();

export default planService;
